import AbstractType from './AbstractType';
import GroupFilter from './GroupFilter';
import TextFilter from './TextFilter';

export const searchTypes = {
  AbstractType,
  GroupFilter,
  TextFilter,
};
